import gql from 'graphql-tag';
import { GqlTag, GqlTagFragment } from '../fragments/tag';

export interface Data {
  tags: GqlTag[];
}

export interface Variables {
  organizationId: number;
}

export const QUERY = gql`
  query Tags($organizationId: Int!) {
    tags(organizationId: $organizationId) {
      ...TagFields
    }
  }
  ${GqlTagFragment}
`;
